/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.weather')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortWeatherPageServerSideProps } from 'page-components/resort/weather';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchResortSlugs } from 'util/fetchResortSlugs';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortWeatherPageServerSideProps);
/* export const getStaticPaths = async () => packPaths((await fetchResortSlugs('resort.weather')).map((res) => ({
  region: res.region,
  resort: res.slug,
}))); */
